import React from 'react'
import { Navigate } from "react-router-dom";
import SecretCodePage from './SecretCodePage';

export default function SecurityCheckPage(props) {
    const hasSecretCode = localStorage.getItem("secretCode");
    return hasSecretCode === (process.env.REACT_APP_SECRET_CODE*(new Date().getDate())).toString() ? props.children : 
    // <Navigate to={`/secret-code-prompt?redirect=${path}`} replace />;
    <SecretCodePage></SecretCodePage>
}
